<h2 mat-dialog-title>Add subdomain</h2>
<p class="subtitle">{{ data.subTitle }}</p>
<mat-dialog-content>
  <form [formGroup]="form">
    <app-input-field
      label="Subdomain name"
      formControlName="domain"
      type="text"
      [errorMessages]="errors['domain']"
      [suffixText]="'.' + data.domain"
    ></app-input-field>

    <div class="checkboxes">
      <mat-checkbox formControlName="emailService">Enable email service</mat-checkbox>
      <mat-checkbox formControlName="wordpress">Install wordpress</mat-checkbox>
    </div>
  </form>
</mat-dialog-content>
<mat-dialog-actions>
  <button matButton="filled" (click)="submit()" [disabled]="form.invalid">Add Website</button>
  <button matButton="elevated" (click)="close()">Close</button>
</mat-dialog-actions>
